<template>
  <ElTable
    :data="data"
    row-key="token"
    cell-class-name="app-releases-table__cell"
    class="app-releases-table"
  >
    <ElTableColumn type="expand">
      <template slot-scope="{ row: releaseRow }">
        <ReleasePackagesTable :release="releaseRow" />
      </template>
    </ElTableColumn>

    <ElTableColumn min-width="100" :label="$t('APP.RELEASES.VERSION')">
      <template slot-scope="{ row: releaseRow }">
        {{ getVersion(releaseRow) }}
      </template>
    </ElTableColumn>
    <ElTableColumn min-width="100" :label="$t('APP.RELEASES.UPLOAD_DATE')">
      <template slot-scope="{ row: { uploadDate } }">
        {{ translateDate(uploadDate, lang) }}
      </template>
    </ElTableColumn>
    <ElTableColumn min-width="100" :label="$t('APP.RELEASES.STATE')">
      <template slot-scope="{ row }">
        {{ getState(row) }}
      </template>
    </ElTableColumn>
    <ElTableColumn
      v-if="app.betaEnabled || app.alphaEnabled"
      min-width="100"
      :label="$t('APP.RELEASES.GROUP')"
    >
      <template slot-scope="{ row: { releaseGroups } }">
        {{ getGroup(releaseGroups) }}
      </template>
    </ElTableColumn>
    <ElTableColumn min-width="300">
      <template slot-scope="{ row: releaseRow }">
        <ReleaseActions :release="releaseRow" />
      </template>
    </ElTableColumn>

    <template slot="empty">
      {{ $t('APP.RELEASES.NO_PACKAGES') }}
    </template>
  </ElTable>
</template>

<script>
import { translateDate } from '@/utils/date';
import appState from '@/mixins/appState';
import packageName from '@/mixins/packageName';
import lang from '@/mixins/lang';
import ReleasePackagesTable from './ReleasePackagesTable';
import ReleaseActions from './ReleaseActions';
import { mapGetters } from 'vuex';
import { APP_DETAILS } from '@/store/types';

export default {
  name: 'AppReleasesTable',
  components: {
    ReleasePackagesTable,
    ReleaseActions,
  },
  mixins: [lang, appState, packageName],
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      autoPublish: true,
    };
  },
  computed: {
    ...mapGetters({
      app: APP_DETAILS,
    }),
  },
  methods: {
    translateDate,
    getVersion(release) {
      return release.packages.length && release.packages[0].versionName;
    },
    getState({ publishState }) {
      return this.getReleaseState(publishState);
    },
    getGroup(releaseGroups) {
      let releaseGroup;
      releaseGroups?.some(groupName => {
        if (groupName.enabled) {
          releaseGroup =
            groupName.name == 'beta'
              ? this.$t('APP.RELEASES.BETA')
              : this.$t('APP.RELEASES.ALPHA');

          return true;
        }
        return false;
      });
      return releaseGroup || this.$t('APP.RELEASES.PUBLIC');
    },
  },
};
</script>

<style lang="scss">
.app-releases-table {
  &__cell {
    border-bottom: 0 !important;
  }

  &__button {
    margin-left: calc($global-margin / 2) !important;

    @include rtl() {
      margin-left: 0 !important;
      margin-right: calc($global-margin / 2);
    }
  }

  &__edit.is-disabled,
  &__edit.is-disabled:hover {
    color: color.scale($lb-lighter-gray, $lightness: -20%) !important;
    border-color: color.scale($lb-lighter-gray, $lightness: -20%) !important;
    background: transparent !important;
  }

  @include breakpoint(medium down) {
    &__edit > span {
      display: none;
    }
  }

  .el-table {
    &__row {
      &--no-expand .el-table__expand-icon {
        display: none;
      }

      &.expanded {
        background: $--background-color-base;
      }
    }

    &__auto-publish.el-switch__label span {
      font-size: rem-calc(11);
      margin-right: $global-margin;
    }

    &__expanded-cell {
      padding: 0 !important;
    }
  }
}
</style>
